import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function allowSaveWithPaymentValidator(
  isPayment: () => boolean
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const paymentValue: boolean = isPayment();

    if (paymentValue) {
      return !value ? { allowSaveWithPayment: true } : null;
    } else {
      return null;
    }
  };
}
